import React, { useMemo } from 'react';
import { CHIP_COLORS, breakdownBet, toColumns, buildAllInPyramid, formatAmount } from '../../utilities/chips';
import './ChipStack.css';

const CHIP_SIZE = 18;  // px diameter
const CHIP_OFFSET = 5; // px vertical offset between chips in a column

// Inline colors for one chip disc — also used by the flight clones in useChipAnimations.
export const chipStyle = (denom) => {
  const c = CHIP_COLORS[denom] || CHIP_COLORS[1];
  return { background: c.bg, borderColor: c.edge };
};

// Renders an amount as columns of colored chip discs with the TRUE value beside it.
// All rounding lives in chips.js and is visual only — the label is never rounded.
const ChipStack = ({ amount, isAllIn = false, seed = 0, scale = 1, label = true }) => {
  const columns = useMemo(
    () => (isAllIn ? buildAllInPyramid(amount, seed, scale) : toColumns(breakdownBet(amount, scale))),
    [amount, isAllIn, seed, scale]
  );

  if (!(amount > 0) || columns.length === 0) return null;

  return (
    <div className="chip-stack">
      <div className="chip-columns">
        {columns.map((col, ci) => (
          <div
            key={ci}
            className="chip-column"
            style={{ height: CHIP_SIZE + (col.length - 1) * CHIP_OFFSET }}
          >
            {col.map((denom, i) => (
              <div
                key={i}
                className="chip"
                style={{ ...chipStyle(denom), bottom: i * CHIP_OFFSET, zIndex: i + 1 }}
              />
            ))}
          </div>
        ))}
      </div>
      {label && <div className="chip-amount">{formatAmount(amount)}</div>}
    </div>
  );
};

export default ChipStack;
